import { StubTabBody, StubTabRow } from "./_StubTab";

export function TokenTab(): JSX.Element {
  return (
    <StubTabBody
      summary="Token flywheel hooks. Becomes live once KotH fees route through a token swap instead of plain lamport transfers."
    >
      <StubTabRow
        label="simulate touch-fee → token-buy swap"
        hint="Plan: route a KOTH_BASE_FEE_LAMPORTS amount through Jupiter into $TICKER, then deposit into the round PDA."
      />
      <StubTabRow
        label="show wallet token balance + holder tier"
        hint="Read the SPL balance for the configured mint, surface the tier the wallet falls into."
      />
      <StubTabRow
        label="trigger buyback-on-settle"
        hint="On end_round, swap a slice of the pot into the token, split between burn and winner payout."
      />
      <StubTabRow
        label="verify holder gate"
        hint="If gating is on, confirm a sub-threshold wallet is rejected and an above-threshold wallet is accepted."
      />
    </StubTabBody>
  );
}
